export const LOADING_DELIVERYNOTES = "LOADING_DELIVERYNOTES";
export const GET_DELIVERYNOTES_LIST = "GET_DELIVERYNOTES_LIST";
export const REMOVE_DELIVERYNOTES = "REMOVE_DELIVERYNOTES";
export const ADD_DELIVERYNOTES = "ADD_DELIVERYNOTES";
export const UPDATE_DELIVERYNOTES = "UPDATE_DELIVERYNOTES";
export const GET_DELIVERYNOTESBYID = "GET_DELIVERYNOTESBYID";
export const GET_DELIVERYBYID_SIGNATURE = "GET_DELIVERYBYID_SIGNATURE";
export const ADD_DELIVERY_SIGNATURE = "ADD_DELIVERY_SIGNATURE";
export const GET_DELIVERYNOTESBYIDINVOICE = "GET_DELIVERYNOTESBYIDINVOICE";